<template>
  <div v-show="false"
       class="page-header">
    <h4>
      {{ title }}
    </h4>
  </div>
</template>
<script>
export default {
  name: "pageHeader",
  props: ["title"],
  data () {
    return {};
  },
  mounted () { },
  methods: {}
};
</script>

